import AccountManagementPage from "../../../components/shared/accounts/AccountManagementPage";
import { OWNER_EMPLOYEE_CONFIG } from "../../../constants/accountManagementConfig";

const OwnerEmployeeListPage = () => <AccountManagementPage config={OWNER_EMPLOYEE_CONFIG} />;

export default OwnerEmployeeListPage;
